/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useContext } from 'react';
import MobileContext from 'context/MobileContext';
import styles from './style.module.css';
import { FSFHorizontalLogo } from 'assets/icons';

const Header = () => {
  const isMobile = useContext(MobileContext);

  return (
    <>
      <div className={isMobile ? styles.mobileWrapper : styles.wrapper}>
        <img
          src={FSFHorizontalLogo}
          alt="logo"
          className={isMobile ? styles.mobileLogo : styles.logo}
        />
      </div>
    </>
  );
};

export default Header;
